import * as cookies from '../lib/cookies'

addEventListener('DOMContentLoaded', function (event) {
	const cookieBar = document.getElementById('ck-banner')
	if (!cookieBar) {
		return
	}

	cookieBar.querySelector('#ck-banner-close')?.addEventListener('click', function (event) {
		cookieBar.remove()
	})

	cookieBar.querySelector('#ck-banner-accept').addEventListener('click', function (event) {
		cookies.set('c_enabled', 'cookie-analytics', 365)
		cookieBar.remove()
	})

	cookieBar.querySelector('#ck-banner-decline').addEventListener('click', function (event) {
		cookies.set('c_enabled', 'false', 365)
		cookieBar.remove()
	})
})